import React, { useEffect } from 'react'
import { get, isEmpty } from 'lodash'
import ReactHtmlParser from 'react-html-parser'
import NewsBlock from 'components/organisms/NewsBlock'
import MediaGrid from 'components/organisms/MediaGrid'
import PublishedAt from 'components/molecules/PublishedAt'
import Typography from 'components/atoms/Typography'
import dataGa from 'helpers/dataGa'
import { DateTime } from 'luxon'
import { Container, Row, Col } from 'react-bootstrap'

const News = (props) => {
  const { data, user, refs } = props
  const entity = get(data, 'route.entity') || { content: [] }
  const title = get(entity, 'title')
  const summary = get(entity, 'body.summary')
  const description = get(entity, 'body.value')
  const downloads = get(entity, 'downloads')
  const gallery = get(entity, 'gallery')
  const created = DateTime.fromJSDate(new Date(get(entity, 'created') * 1000)).toFormat("dd/MM/yyyy H:mm'h'")
  const updated = DateTime.fromJSDate(new Date(get(entity, 'updated') * 1000)).toFormat("dd/MM/yyyy H:mm'h'")
  const hasGallery = gallery && !isEmpty(gallery)

  useEffect(() => {
    dataGa(entity.dataGa)
  }, [])

  return (
    <>
      <div className="bg-gray-400 section-spacing">
        <Container>
          <Row>
            <Col>
              <Typography variant="p" color="primary" cssClass="text-left title-bold-lg">
                {title}
              </Typography>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        {summary && (
          <Row className="pt-4">
            <Col md={9}>
              <Typography color="primary">{summary}</Typography>
            </Col>
          </Row>
        )}

        {description && (
          <Row>
            <Col md={9}>
              <NewsBlock
                text={ReactHtmlParser(description)}
                downloads={downloads}
                created={created}
                updated={updated}
                hasGallery={hasGallery}
                className='py-4'
              />
            </Col>
          </Row>
        )}

        {hasGallery && (
          <>
            <Row>
              <Col md={12}>
                <Typography cssClass='title-bold-md' color="primary">Galeria de imagens</Typography>
                <MediaGrid medias={gallery} className='section-spacing' />
              </Col>
            </Row>

            <Row>
              <Col md={9}>
                <PublishedAt created={created} updated={updated} />
              </Col>
            </Row>
          </>
        )}
      </Container>
    </>
  )
}

export default News
